module.exports = __webpack_public_path__ + "static/media/hero-3.4fe45ca4.jpg";